<template>
  <el-dialog title="选择志愿者" :visible.sync="dialogVisible" :before-close="handleBeforeClose" width="850px">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form :model="form" class="com-search-box" ref="form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="text">
              <el-input v-model="form.text" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="time">
              <el-date-picker v-model="form.time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择注册时间"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>

      </div>

    </div>
    <div class="table mt-20">
      <el-table ref="multipleTable" reserve-selection @select="handleSelectionChange" @select-all="selectAll" stripe :data="tableData"
                :row-key="getRowKeys">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="name" label="姓名" min-width="9%" show-overflow-tooltip></el-table-column>
        <el-table-column prop="phone" label="联系电话" min-width="14%"></el-table-column>
        <el-table-column prop="registrationTime" label="注册时间" min-width="12%">
          <template slot-scope="scope"><span>{{ scope.row.registrationTime | filterTime}}</span></template>
        </el-table-column>
        <el-table-column prop="volunteerStatus" label="志愿者状态" min-width="12%">
          <template slot-scope="scope"><span>{{ scope.row.volunteerStatus | filterVolunteerStatus(that)}}</span></template>
        </el-table-column>
        <el-table-column prop="totalServiceTime" label="服务总时长" min-width="12%">
          <template slot-scope="scope"><span>{{ scope.row.totalServiceTime}}小时</span></template>
        </el-table-column>
        <el-table-column prop="numberActivities" label="活动场次" min-width="10%">
        </el-table-column>
        <el-table-column prop="explanationDuration" label="讲解时长" min-width="10%"></el-table-column>
        <el-table-column prop="explanationNum" label="讲解场次" min-width="10%"> </el-table-column>
      </el-table>

      <div class="pagination-container paging">
        <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
                       layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
    <div slot="footer" class="footer mt-30">
      <el-button @click="cancel">取消</el-button>
      <el-button @click="submit" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      that: this,
      exhibitionId: '',
      chooseRows: [],
      total: 0,
      tableData: [],
      levelList: [],
      dialogVisible: false,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      form: {
        text: '',
        time: ''
      },
      getRowKeys(row) {
        return row.id
      }
    }
  },

  filters: {
    filterVolunteerStatus(status, that) {
      let obj = that.levelList.filter((item) => {
        return item.dictCode == status
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    },

    filterTime(time) {
      return time.slice(0, 10)
    }
  },

  // watch: {
  //   tableData(newV) {
  //     this.$nextTick(() => {
  //       this.chooseRows.forEach(item => {
  //         this.$refs.multipleTable.toggleRowSelection(item);//这个就是回显的核心
  //       })
  //     })
  //   },
  // },

  methods: {
    init(arr, exhibitionId) {
      this.chooseRows = arr
      this.exhibitionId = exhibitionId
      this.listQuery = {
        currentPage: 1,
        size: 10
      }
      this.getDropdownValue()
      this.initList()
    },

    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    initList() {
      this.tableData = []
      let param = {}
      if (this.exhibitionId) {
        param.exhibitionId = this.exhibitionId
      } else {
        param.status = '1, 2, 3'
      }
      this.$api.volunteer
        .getVolunteerAdultList({
          ...this.form,
          ...this.listQuery,
          ...param
        })
        .then((res) => {
          if (res.success) {
            let tempArr = []
            this.tableData = res.result.records
            this.total = res.result.total
            this.echoSelected()
            this.dialogVisible = true
          }
        })
        .catch((err) => {})
    },

    // 回显选中
    echoSelected() {
      if (this.chooseRows.length > 0) {
        this.$nextTick(() => {
          this.tableData.forEach((item) => {
            if (this.chooseRows.some((user) => user.id === item.id)) {
              // 存在添加
              this.$refs.multipleTable.toggleRowSelection(item)
            }
          })
        })
      }
    },

    // 获取下拉状态选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['volunteer_grade']
        })
        .then((res) => {
          if (res.success) {
            var state = res.result
            let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.levelList = firstArr.concat(state['volunteer_grade'])
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },

    selectAll(arr) {
      if (arr.length !== 0) {
        arr.forEach((item) => {
          const bool = this.chooseRows.some((user) => user.id === item.id)
          if (!bool) {
            // 不存在添加
            this.chooseRows.push(item)
          }
        })
      } else {
        // 取消全选
        this.tableData.forEach((item) => {
          this.chooseRows = this.chooseRows.filter(
            (user) => user.id !== item.id
          )
        })
      }
    },

    handleSelectionChange(arr, row) {
      console.log(row)
      const bool = this.chooseRows.some((user) => user.id === row.id) // 存在返回true 否则返回false
      if (bool) {
        // 存在删除
        this.chooseRows = this.chooseRows.filter((user) => user.id !== row.id)
      } else {
        // 添加
        this.chooseRows.push(row)
      }
    },

    handleBeforeClose() {
      this.dialogVisible = false
    },

    submit() {
      if (this.chooseRows && this.chooseRows.length < 0) {
        this.$message.warning('请选择志愿者')
        return
      }
      this.$emit('setNum', this.chooseRows)
      this.dialogVisible = false
    },

    cancel() {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
      this.chooseRows = []
      this.tableData = []
    }
  }
}
</script>

<style lang='scss' scoped>
/deep/ .el-dialog__header {
  padding-bottom: 0;
}
</style>